import React from 'react'
import {connect} from 'react-redux'
import MainPaper from '../../component/MainPaper'
import PaymentResult from '../../component/PaymentResult'
import SuccessfulPaymentSummary from '../../component/SuccessfulPaymentSummary'
import NotSuccessfulPaymentSummary from '../../component/NotSuccessfulPaymentSummary'
import EndButtons from '../../component/EndButtons'
import Main from "../Main";

/**
 * The piece of UI that shows the Feedback to the user after a normal payment has been.
 *
 * @param formData: The data from the form.
 * @param resultData: The result of the payment.
 * @param cardData: The card data received from the form
 */
const Feedback = ({formData, resultData, cardData}) =>
    <MainPaper after={<EndButtons successUrl={formData.successUrl}/>}>
        <PaymentResult success={resultData.success}/>
        {resultData.success
            ? <SuccessfulPaymentSummary {...resultData} cardData={cardData} />
            : <NotSuccessfulPaymentSummary error={resultData.error} resultData={resultData} />}
    </MainPaper>

const mapStateToProps = state => ({
    formData: state.forms.formData,
    resultData: state.forms.resultData,
    cardData: state.formInputData.cardData
})

const DataBound = connect(mapStateToProps)(Feedback)

export default Main(DataBound)
